import stylesHeader from '../../styles/module/Header.module.css';
import React, {useEffect, useState} from "react";
import {useRef} from 'react';
import gsap from "gsap";
// import {useHistory} from "react-router-dom";
import {FaSquarePhoneFlip} from "react-icons/fa6";
import {FaMapLocationDot} from "react-icons/fa6";
import {GrMapLocation} from "react-icons/gr";
import {MdOutlinePhoneInTalk} from "react-icons/md";
import {CiClock2, CiMail} from "react-icons/ci";
import {useNavigate} from "react-router-dom";
import {smoothScrollToId} from "../../utils/helper.jsx";
import styles from '../../styles/module/SocialMedia.module.css';

import {FaFacebook, FaInstagram, FaGoogle, FaClock, FaEnvelope, FaTiktok} from 'react-icons/fa';

export const linkLogoWhite = "assets/logo/logo kando2-trang.png"
export const linkWave = "assets/logo/waves.png"
export const linkLogo = "assets/logo/logo-kando.png"
export  const facebookLink = 'https://www.facebook.com/people/Zenchi-Leipzig/61565552949531/'; // Replace with your Facebook page URL
export  const instagramLink = 'https://www.instagram.com/zenchi_leipzig/'; // Replace with your Instagram page URL
export const googleMapsLink = 'https://maps.app.goo.gl/DRBShZZG2aSu4VPd6'; // Replace with your Google Maps CID
export  const tiktokLink = 'https://www.tiktok.com/@zenchileipzig'; // Replace with your Google Maps CID
export  const phoneExport = '034124837553'; // Replace with your Google Maps CID
export  const timeExport = 'Mo-Do: 11:30-22:00 / Fr-Sa: 11:30-23:00'; // Replace with your Google Maps CID
export  const emailExport = 'info@zenchileipzig.de'; // Replace with your Google Maps CID
export  const addressExport = 'Nikolaistraße 1, 04109 Leipzig'; // Replace with your Google Maps CID

function Header(props) {
    let headerHidden = true
    const [collsep, setCollsep] = useState(false);
    const navigate = useNavigate();

    // Refs cho GSAP
    const headerLabelRefs = useRef([]);
    const headerValRefs = useRef([]);
    const contactBandleRef = useRef(null);
    const buttonIconItemsRef = useRef([]);
    const logoBaseRef = useRef(null);
    const menuRef = useRef(null);
    const navLinkRefs = useRef([]);
    const [showContactHeader, setShowContactHeader] = useState(true);
    let lastScrollY = 0;
    // Hàm thêm ref vào mảng (tránh trùng)
    const addToRefs = (refArray, el) => {
        if (el && !refArray.current.includes(el)) {
            refArray.current.push(el);
        }
    };

    // Animation khi vào trang
    useEffect(() => {
        const duration = 1.4;
        const stagger = 0.2;
        const delay = 0.4;

        gsap.to(headerLabelRefs.current, {opacity: 1, x: 0, duration, stagger, delay, ease: "power3.inOut"});
        gsap.to(headerValRefs.current, {opacity: 1, x: 0, duration, stagger, delay, ease: "power3.inOut"});
        gsap.to(contactBandleRef.current, {opacity: 1, x: 0, duration, delay, ease: "power3.inOut"});
        gsap.to(buttonIconItemsRef.current, {opacity: 1, x: 0, duration, stagger, delay, ease: "power3.inOut"});
        gsap.to(logoBaseRef.current, {opacity: 1, x: 0, duration, delay, ease: "power3.inOut"});
    }, []);
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                // Scroll xuống + đủ xa → ẩn
                setShowContactHeader(false);
            } else if (currentScrollY < lastScrollY) {
                // Scroll lên → hiện
                setShowContactHeader(true);
            }

            lastScrollY = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, {passive: true});

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    // Animation mở/đóng menu
    useEffect(() => {
        const tl = gsap.timeline();

        if (collsep) {
            tl.to(menuRef.current, {
                opacity: 1,
                display: 'flex',
                zIndex: 115,
                x: 0,
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                duration: 1,
                ease: 'power2.inOut'
            });
            tl.to(navLinkRefs.current, {
                opacity: 1,
                marginTop: 0,
                duration: 0.6,
                stagger: 0.1
            }, '-=0.5');
        } else {
            tl.to(navLinkRefs.current, {
                opacity: 0,
                marginTop: '-20px',
                duration: 0.4
            });
            tl.to(menuRef.current, {
                opacity: 0,
                zIndex: -1,
                display: 'none',
                x: '-20%',
                duration: 1,
                ease: 'power2.inOut'
            }, '-=0.3');
        }

        return () => tl.kill();
    }, [collsep]);


    const menu = [
        {
            label: "StartSeite",
            url: "/home",

        },
        {
            label: "Über uns",
            url: "#",
            id: 'about-us',
            nonRedirect: true,
        },
        {
            label: "Tisch reservieren",
            url: "/booking",
        },
        {
            label: "Speisekarte",
            url: "/menu",
        },
        {
            label: "Kontaktieren Sie uns",
            url: "/kontaktieren-sie-uns"
        },

    ]


    return (
        <>
            <div className={stylesHeader.header}>
                <div className={`${stylesHeader.lineInfoHeader} ${showContactHeader ? stylesHeader.visible : stylesHeader.hidden} `}>
                    <div className={` ${stylesHeader.contactHeader}`}>
                        <div className={stylesHeader.wrapPlastic}>
                            <div className={stylesHeader.itemHeader}>
                                <div
                                    className={stylesHeader.headerLabel}
                                    ref={(el) => addToRefs(headerLabelRefs, el)}
                                >
                                    <FaSquarePhoneFlip/>
                                </div>
                                <div
                                    className={stylesHeader.headerVal}
                                    ref={(el) => addToRefs(headerValRefs, el)}
                                >
                                    {phoneExport}
                                </div>
                            </div>
                            <div className={stylesHeader.itemHeader}>
                                <div
                                    className={stylesHeader.headerLabel}
                                    ref={(el) => addToRefs(headerLabelRefs, el)}
                                >
                                    <FaMapLocationDot/>
                                </div>
                                <div
                                    className={`${stylesHeader.headerVal} ${stylesHeader.link}`}
                                    ref={(el) => addToRefs(headerValRefs, el)}
                                    onClick={() => window.open(googleMapsLink, "_blank")} // Replace with your Google Maps link
                                >
                                    {addressExport}
                                </div>
                            </div>
                        </div>

                        <div className={stylesHeader.wrapPlastic}>
                            <div className={stylesHeader.itemHeader}>
                                <div
                                    className={stylesHeader.headerLabel}
                                    ref={(el) => addToRefs(headerLabelRefs, el)}
                                >
                                    <FaEnvelope/> {/*  Assuming you have an email icon, or replace with another icon */}
                                </div>
                                <div
                                    className={stylesHeader.headerVal}
                                    ref={(el) => addToRefs(headerValRefs, el)}
                                >
                                    <a href={`mailto:${emailExport}`}>{emailExport}</a>
                                </div>
                            </div>
                            <div className={stylesHeader.itemHeader}>
                                <div
                                    className={stylesHeader.headerLabel}
                                    ref={(el) => addToRefs(headerLabelRefs, el)}
                                >
                                    <FaClock/> {/* Assuming you have a clock icon */}
                                </div>
                                <div
                                    className={stylesHeader.headerVal}
                                    ref={(el) => addToRefs(headerValRefs, el)}
                                >
                                    {timeExport}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className={`${stylesHeader.headerContainer} ${stylesHeader.hiddenBgHeader} ${!showContactHeader ?  stylesHeader.visible : stylesHeader.hidden}`}>
                    <div
                        className={stylesHeader.logoBase}
                        ref={logoBaseRef}
                        onClick={() => navigate("/home")}
                    >
                        <img src={linkLogoWhite} width="50" height="50" alt="Logo"/>
                    </div>

                    <div
                        className={stylesHeader.btnMenu}
                        onClick={() => setCollsep(!collsep)}
                    >
                        <div className={`${stylesHeader.menuBtn1} ${collsep ? stylesHeader.active : ""}`}>
                            <div className={stylesHeader.span}></div>
                        </div>
                    </div>

                    <div ref={menuRef} className={stylesHeader.menu}>
                        <img className={stylesHeader.logoBack} src={linkLogoWhite} width="50" height="50"
                             alt="Logo Background"/>
                        <div className={`${stylesHeader.background} ${stylesHeader.bottom}`}>
                            <img src={linkWave} alt="Wave Background"/>
                        </div>
                        <div
                            className={stylesHeader.exist}
                            onClick={() => setCollsep(false)}
                        >
                            <img src="assets/icon/close-icon.svg" alt="Close"/>
                        </div>

                        <div className={stylesHeader.menuContainerContent}>
                            <div className={stylesHeader.menuContent}>
                                {/* Navigation */}
                                <div className={stylesHeader.menuContainer}>
                                    <div className={stylesHeader.navList}>
                                        {menu?.map(({url, label, target, nonRedirect, id}) => (
                                            <a
                                                key={id}
                                                onClick={() => {
                                                    if (target) window.open(url, target);
                                                    else if (nonRedirect) smoothScrollToId(id, 'start', 'nearest', navigate);
                                                    else navigate(url);
                                                    setCollsep(false);
                                                }}
                                                className={stylesHeader.navLink}
                                                ref={(el) => addToRefs(navLinkRefs, el)}
                                            >
                                                {label}
                                            </a>
                                        ))}
                                    </div>

                                    {/* Social Icons */}
                                    <div className={styles.container}>
                                        <a href={facebookLink} className={styles.link} target="_blank"
                                           rel="noopener noreferrer">
                                            <FaFacebook className={styles.icon}/>
                                        </a>
                                        <a href={instagramLink} className={styles.link} target="_blank"
                                           rel="noopener noreferrer">
                                            <FaInstagram className={styles.icon}/>
                                        </a>
                                        <a href={tiktokLink} className={styles.link} target="_blank"
                                           rel="noopener noreferrer">
                                            <FaTiktok className={styles.icon} />
                                        </a>
                                        <a href={googleMapsLink} className={styles.link} target="_blank"
                                           rel="noopener noreferrer">
                                            <FaGoogle className={styles.icon}/>
                                        </a>
                                    </div>
                                </div>

                                {/* Info */}
                                <div className={stylesHeader.menuContainer}>
                                    <div className={stylesHeader.wrapInfoMenu}>
                                        <div
                                            className={`${stylesHeader.stuff} ${stylesHeader.link}`}
                                            onClick={() => window.open(googleMapsLink, "_blank")}
                                        >
                                            <GrMapLocation/>
                                            {addressExport}
                                        </div>
                                        <div className={stylesHeader.stuff}>
                                            <MdOutlinePhoneInTalk/>
                                            {phoneExport}
                                        </div>
                                        <div className={stylesHeader.stuff}>
                                            <FaEnvelope/>
                                            <a href="mailto:info@zenchileipzig.de"> info@zenchileipzig.de</a>
                                        </div>
                                        <div className={stylesHeader.stuff}>
                                            <CiClock2/>
                                            {timeExport}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default Header;